import AuthLayout from '../../../components/AuthLayout';
import RegisterContainer from '../../../containers/Register';

export default function Register() {
  return (
    <AuthLayout maxWidth="xl" title="رابکس | ثبت‌نام">
      <RegisterContainer />
    </AuthLayout>
  );
}
